<template>
    <div class="cubeSpace final_efisense w-100">
        <section class="medidas_efisense d-flex w-100">

            <section class="seccion-final_footer">
                <div class="seccion-logo_footer">
                    <span class="footer-brand-text fuente-posm">Proactive</span>
                </div>

                <div class="seccion-footer_h2">
                    <h2 class="fuente-nova">Instalaciones que conectan tecnología con cada espacio.
                        Del sureste de México al país entero.
                    </h2>
                </div>


                <div class="seccion_enlaces mt-3">

                    <a href="https://proactive.lat" target="_blank" class="linkAccess fuente-nova">proactive.lat</a>

                    <a href="mailto:hola@proactive.lat" class="linkAccess fuente-nova">hola@proactive.lat</a>

                    <a href="tel:+529999306053" target="_blank" class="fuente-nova linkAccess">+52 (999) 930.60.53</a>
                </div>

                <div class="seccion_redes mt-4">
                    <a href="https://www.facebook.com/proactivelat" class="" target="_blank">Facebook</a>
                    <a href="https://www.instagram.com/proactivelat/" class="mt-3" target="_blank">Instagram</a>
                    <a href="https://wa.me/529999306053" class="mt-3" target="_blank">WhatsApp</a>

                </div>

                <div class="seccion-footer_h3">
                    <h2 class="fuente-nova">Mérida, Yucatán, México
                    </h2>
                </div>
            </section>

            <section class="seccion-dinamica_footer">

                <article class="article_footer">
                    <h2 class="fuente-nova2">Especialidades</h2>
                    <p class="fuente-nova" @click="$router.push('/audio')">Audio</p>
                    <p class="fuente-nova" @click="$router.push('/video')">Video</p>
                    <p class="fuente-nova" @click="$router.push('/datos')">Datos</p>
                    <p class="fuente-nova" @click="$router.push('/domotica')">Domótica</p>
                </article>

                <article class="article_footer">
                    <h2 class="fuente-nova2">Contacto</h2>
                    <p class="fuente-nova"><a href="tel:+529999306053" class="footer-link">+52 (999) 930.60.53</a></p>
                    <p class="fuente-nova"><a href="mailto:hola@proactive.lat" class="footer-link">hola@proactive.lat</a></p>
                    <p class="fuente-nova"><a href="https://maps.app.goo.gl/ucEpt5utRkaAQeBm9" target="_blank" rel="noopener noreferrer" class="footer-link">Dirección</a></p>
                </article>

            </section>

        </section>

    </div>
</template>

<script>
export default {
    name: 'page13',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {}
    },
}
</script>
<style lang="css" scoped>
.medidas_efisense {
    display: flex;
    justify-content: space-between;
    max-width: 1400px;
    margin: 0 auto;
    padding: 80px 40px;
    gap: 60px;
}

.final_efisense {
    background-color: #272727 !important;
}

.seccion-final_footer {
    max-width: 320px;
    color: white !important;
}

.seccion-final_footer .seccion-logo_footer {
    max-width: 220px;
    margin: 0;
}

.seccion-final_footer .seccion-logo_footer img {
    width: 100%;
}

.footer-brand-text {
    font-size: 32px;
    font-weight: 700;
    color: white;
    letter-spacing: -1px;
}

.footer-link {
    color: rgba(255, 255, 255, 0.7) !important;
    text-decoration: none;
    transition: color 0.2s ease;
}

.footer-link:hover {
    color: white !important;
}

.seccion-final_footer .seccion-footer_h2 h2 {
    font-size: 15px;
    font-weight: 400;
    line-height: 1.6;
    margin-top: 24px;
    color: rgba(255, 255, 255, 0.85);
}

.seccion-final_footer .seccion-footer_h3 h2 {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    margin-top: 24px;
    color: rgba(255, 255, 255, 0.5);
}

.seccion-final_footer .seccion_enlaces {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    margin-top: 20px;
}

.seccion-final_footer .seccion_enlaces a {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.2s ease;
}

.seccion-final_footer .seccion_enlaces a:hover {
    color: white !important;
}

.seccion-final_footer .seccion_redes {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 8px;
}

.seccion-final_footer .seccion_redes a {
    color: white !important;
    font-weight: 500;
    text-decoration: none;
    font-size: 15px;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: opacity 0.2s ease;
}

.seccion-final_footer .seccion_redes a:hover {
    opacity: 0.7;
}

.seccion-final_footer .seccion_redes img {
    width: 20px;
    height: 20px;
}

.seccion-dinamica_footer {
    padding-top: 80px;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 40px 60px;
    justify-content: flex-start;
}

.seccion-dinamica_footer .article_footer {
    color: white;
    min-width: 180px;
    max-width: 220px;
}

.seccion-dinamica_footer .article_footer h2 {
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 16px;
    color: white;
    letter-spacing: 0.02em;
}

.seccion-dinamica_footer .article_footer p {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
    margin-left: 0;
    cursor: pointer;
    transition: color 0.2s ease;
}

.seccion-dinamica_footer .article_footer p:hover {
    color: white;
}

@media screen and (max-width: 992px) {
    .medidas_efisense {
        padding: 60px 30px;
        gap: 40px;
    }

    .seccion-dinamica_footer {
        padding-top: 40px;
        gap: 30px 40px;
    }

    .seccion-dinamica_footer .article_footer {
        min-width: 150px;
    }
}

@media screen and (max-width: 550px) {
    .medidas_efisense {
        flex-direction: column;
        padding: 50px 20px;
    }

    .seccion-final_footer {
        max-width: 100%;
    }

    .seccion-final_footer .seccion-logo_footer {
        max-width: 180px;
    }

    .seccion-dinamica_footer {
        padding-top: 30px;
        gap: 24px 30px;
    }

    .seccion-dinamica_footer .article_footer {
        min-width: 140px;
        max-width: 45%;
    }

    .seccion-dinamica_footer .article_footer h2 {
        font-size: 14px;
        margin-bottom: 12px;
    }

    .seccion-dinamica_footer .article_footer p {
        font-size: 13px;
        margin-bottom: 8px;
    }
}
</style>